import React from 'react';
import { injectIntl } from 'react-intl';
import _ from 'lodash';
import { Form, Input, Button, Icon, Select } from 'antd';
import './ResumeLibraryLoginForm.scss';
import { getJobBoardErrorDetails } from '../../../Utils/JobBoardUtils';
import placeholder from '../../Placeholders/PlaceholdersMessages';

class ResumeLibraryLoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // To disabled submit button at the beginning.
    const { form } = this.props;
    form.validateFields();
  }

  handleSubmit(isAuthenticated) {
    const { form, authenticate, jobBoard, disconnect, index, clearAccount, addSelectedCountry, removeSelectedCountry } =
      this.props;
    form.validateFields((err, values) => {
      if (!err) {
        const countryCode = values[`${jobBoard}countryCode`];
        if (isAuthenticated) {
          disconnect(jobBoard, countryCode, index, removeSelectedCountry);
        } else {
          authenticate(
            jobBoard,
            {
              Username: values[`${jobBoard}userName`],
              Password: values[`${jobBoard}password`],
              AccountId: values[`${jobBoard}accountId`],
              AccountKey: values[`${jobBoard}accountKey`],
              CountryCode: countryCode,
            },
            index,
            clearAccount,
            addSelectedCountry
          );
        }
      }
    });
  }

  render() {
    const {
      form,
      jobBoard,
      portalSettings,
      account,
      index,
      Countries,
      countriesMenu,
      credentialsValidator,
      isAuthenticated,
      intl,
    } = this.props;
    const credentials = account;
    const username = `${jobBoard}userName`;
    const password = `${jobBoard}password`;
    const mandatoryFields = [username, password];
    const usernameError = form.isFieldTouched(username) && form.getFieldError(username);
    const passwordError = form.isFieldTouched(password) && form.getFieldError(password);
    const errorDetail = getJobBoardErrorDetails(credentials, jobBoard);
    return (
      <div className="portal-login-form">
        <div className={isAuthenticated ? 'authentication-tick' : 'authentication-untick'}>
          {isAuthenticated ? <Icon type="check-circle" className="authentication-check-circle" theme="filled" /> : null}
        </div>
        <div className="error-message-with-form">
          <Form>
            <div className="jobboard-credentials-container">
              <div className="jobboard-input-container">
                <Form.Item>
                  <div className="jobboard-country-code">
                    {form.getFieldDecorator(`${jobBoard}countryCode`, {
                      initialValue: credentials.CountryCode || (Countries && Countries[0]),
                    })(
                      <Select
                        className="jobboard-country-code-select"
                        disabled={isAuthenticated || countriesMenu.length < 2}
                      >
                        {countriesMenu}
                      </Select>
                    )}
                  </div>
                </Form.Item>
              </div>
              <div className="jobboard-input-container">
                <Form.Item validateStatus={usernameError ? 'error' : ''} help="">
                  {form.getFieldDecorator(`${jobBoard}userName`, {
                    initialValue: credentials.Username,
                    rules: [{ required: true, message: '', validator: credentialsValidator.validateEmptyField }],
                  })(
                    <Input
                      placeholder={intl.formatMessage({ ...placeholder.usernameLabel })}
                      className="resume-library-username"
                      autoComplete="false"
                      readOnly={isAuthenticated}
                    />
                  )}
                </Form.Item>
                <Form.Item>
                  {form.getFieldDecorator(`${jobBoard}accountId`, { initialValue: credentials.AccountId })(
                    <Input
                      placeholder={intl.formatMessage({ ...placeholder.accountIdLabel })}
                      className="resume-library-account-id"
                      autoComplete="false"
                      readOnly={isAuthenticated}
                    />
                  )}
                </Form.Item>
              </div>
              <div className="jobboard-input-container">
                <Form.Item validateStatus={passwordError ? 'error' : ''} help="">
                  {form.getFieldDecorator(`${jobBoard}password`, {
                    initialValue: isAuthenticated ? '********' : undefined,
                    rules: [{ required: true, message: '', validator: credentialsValidator.validateEmptyField }],
                  })(
                    <Input
                      type="password"
                      placeholder={intl.formatMessage({ ...placeholder.passwordLable })}
                      className="resume-library-password"
                      autoComplete="new-password"
                      readOnly={isAuthenticated}
                    />
                  )}
                </Form.Item>
                <Form.Item>
                  {form.getFieldDecorator(`${jobBoard}accountKey`, {
                    initialValue: credentials.AccountKey,
                  })(
                    <Input
                      placeholder={intl.formatMessage({ ...placeholder.accountKeyLabel })}
                      type="password"
                      autoComplete="new-password"
                      className="resume-library-account-key"
                      readOnly={isAuthenticated}
                    />
                  )}
                </Form.Item>
              </div>
              <Form.Item>
                <div className="btn-container">
                  <Button
                    // type="primary"
                    htmlType="submit"
                    loading={_.get(portalSettings, ['AuthenticationApiStatus', index], '') === 'INPROGRESS'}
                    onClick={() => this.handleSubmit(isAuthenticated)}
                    className={isAuthenticated ? 'disconnect-button' : 'authenticate-button'}
                    shape="round"
                    disabled={
                      credentialsValidator.hasError(form.getFieldsError()) ||
                      credentialsValidator.anyFieldEmpty(form, mandatoryFields)
                    }
                    block
                  >
                    {isAuthenticated ? 'Disconnect' : 'Authenticate'}
                  </Button>
                </div>
              </Form.Item>
            </div>
          </Form>
          <div className="error-message">{errorDetail.Message}</div>
        </div>
      </div>
    );
  }
}

export default injectIntl(Form.create()(ResumeLibraryLoginForm));
export { ResumeLibraryLoginForm as ResumeLibraryLoginWithoutForm };
